import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/MensagemAlerta.css';

const MensagemAlerta = ({ tipo, mensagem, onClose }) => {
  const { t } = useTranslation('common');

  if (!mensagem) return null;

  return (
    <div className={`mensagem-alerta ${tipo}`} role={tipo === 'error' ? 'alert' : 'status'}>
      <span>{mensagem}</span>
      <button type="button" onClick={onClose} aria-label={t('closeNotification')}>x</button>
    </div>
  );
};

export default MensagemAlerta;
